import React from "react";
import styled,{ keyframes } from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import Card from "../subComponent/Card";
import Footer from "./Footer";
import NewArrivalsBanner from "./NewArrivalsBanner";
import FeaturedProduct from "./FeaturedProduct";
import SalesBanner from "./SaleBanner";


const Categories = () => {
  const { categories } = useStateContext();
  return (
    <Component>
      <CategoriesWrapper>
        {/* Text Categories */}
        <TextCategories>
          <h1>CATEGORIES</h1>
        </TextCategories>

        {/* Category Cards */}
        <Category>
          {categories?.length > 0 ? (
            <CardWrapper>
              {categories.map((mappedcategory) => (
                <Card
                  category={mappedcategory}
                  key={mappedcategory.categories_id}
                />
              ))}
            </CardWrapper>
          ) : (
            <CardWrapper>
              {[1,2,3,4,7,8,9,10,11].map((details, i) => (
            <Loader>
            
         
            </Loader>
          ))}
            </CardWrapper>
          
          )}
         
        </Category>
      </CategoriesWrapper>
      <NewArrivalsBanner />
      <FeaturedProduct />
      <SalesBanner/>
      {/* Footer */}
      <FooterContainer>
        <Footer />
        <div className="buttom">
          <h1 className="Logo">
            Ma<span style={{ color: "pink" }}>t</span>rix
          </h1>
          <span>Built by Babzz</span>
        </div>
      </FooterContainer>
    </Component>
  );
};

export default Categories;

const Component = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f3e4e4;
  width: 100%;
  flex-direction: column;
`;

const CategoriesWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f3e4e4;
  width: 100%;
`;

const TextCategories = styled.div`
  width: 17%;

  border-right: 2px solid pink;
  position: relative;
  @media (max-width: 1031px) {
    width: 0%;
    display: none;
  }
  h1 {
    position: absolute;
    opacity: 0.1;
    top: 17rem;
    left: -18%;
    font-size: 70px;
    transform: rotate(-90deg);
  }
`;
const Category = styled.div`
  width: 83%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10vh;
  @media (max-width: 1031px) {
    width: 100%;
    align-items: flex-start;
  }
`;

const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;

  @media (max-width: 800px) {
    gap: 10px;
  }
  @media (max-width: 660px) {
    gap: 8px;
  }
  @media (max-width: 430px) {
    gap: 8px;
    grid-template-columns: 1fr 1fr;
  }
`;

const FooterContainer = styled.div`
  margin-top: 20px;
  padding: 20px 80px;
  display: flex;
  flex-direction: column;
  background-color: #393636;
  color: white;
  @media (max-width: 470px) {
    padding: 5px 20px;
  }
  .buttom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .Logo {
    font-family: "Lobster", cursive;
    font-size: 44px;
    @media (max-width: 470px) {
      font-size: 24px;
    }
    cursor: pointer;

    a {
      text-decoration: none;
      color: black;
    }
  }
`;

const shineAnimation = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 0;
  }
`;

const Loader = styled.div`
 height: 280px;
  width: 280px;
 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #f4d2e6;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      #ada9ab 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 200% 100%;
    background-position: -100% 0;
    animation: ${shineAnimation} 2s linear infinite;
  }
  @media (max-width: 1011px) {
    width: 240px;
    height: 240px;
  }
  @media (max-width: 914px) {
    width: 200px;
    height: 200px;
  }

  @media (max-width: 800px) {
    width: 170px;
    height: 170px;
  }
  @media (max-width: 660px) {
    width: 140px;
    height: 140px;
  }

  @media (max-width: 580px) {
    width: 110px;
    height: 110px;
    border-radius: 4px;
  }

  @media (max-width: 470px) {
    width: 140px;
    height: 140px;
  }
  @media (max-width: 400px) {
    width: 120px;
    height: 120px;
  }
`;
